// The browser has no navigator.credentials/WebAuthn support at all (see
// isPasskeySupported in ./webauthn). Thrown before ever touching the network.
export default class PasskeyUnsupportedError extends Error {}
